import type { TConstraints } from '@feathr/rachis';

import { createDimensionValidator, CreativeClass, ValidDimensions } from './creatives_base';
import type { ICreativeAuditStatus, IDisplayCreative } from './creatives_display';
import { DisplayCreative } from './creatives_display';

// =============================================================================
// Video Creative Types
// =============================================================================

export const VALID_VIDEO_FORMATS = ['video/mp4', 'video/quicktime'];

export interface IVideoCreative extends IDisplayCreative {
  readonly _cls: CreativeClass.DisplayVideo;
  skippable: boolean;
  audit_statuses: ICreativeAuditStatus[];
}

// =============================================================================
// Video Creative Class
// =============================================================================

/**
 * VideoCreative handles video display creatives.
 * Supports MP4 and MOV formats.
 */
export class VideoCreative extends DisplayCreative<IVideoCreative> {
  public override readonly className = 'VideoCreative';

  public override get constraints(): TConstraints<IVideoCreative> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [CreativeClass.DisplayVideo],
      },
      mimetype: {
        inclusion: {
          within: VALID_VIDEO_FORMATS,
          message: '^File must be MP4 or MOV format',
        },
      },
      width: {
        ...super.constraints.width,
        equality: createDimensionValidator(ValidDimensions, 'width'),
      },
      height: {
        ...super.constraints.height,
        equality: createDimensionValidator(ValidDimensions, 'height'),
      },
    };
  }

  public override getDefaults(): Partial<IVideoCreative> {
    return {
      ...super.getDefaults(),
      _cls: CreativeClass.DisplayVideo,
    };
  }
}
